import { createEditBlock } from "./base-edit-block";

export const translateBlock = createEditBlock("translate", {
  responseToPatch: (text) => ({ text }),
  additionalParams: (options) => ({
    targetLanguage: options?.targetLanguage,
  }),
});
